import React from 'react'
import { LatLngExpression } from 'leaflet'
import { Popup } from 'react-leaflet'
import Avatar from '@mui/material/Avatar'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import AssignmentRounded from '@mui/icons-material/AssignmentRounded'
import CalendarMonthRounded from '@mui/icons-material/CalendarMonthRounded'
import LocationOnRounded from '@mui/icons-material/LocationOnRounded'
import EnhancedMarker from '../enhanced-marker/enhanced-marker'

type Props = {
  position: LatLngExpression
  imageUrl?: string
  memberName?: string
  memberEmail: string
  datetime: string
  description: string
  precision?: number
}

const MemberMarker: React.FC<Props> = ({ position, imageUrl, memberName, memberEmail, datetime, description, precision }) => {
  return (
    <EnhancedMarker
      position={position}
      icon={
        <Avatar src={imageUrl} {...stringAvatar(memberName)} />
      }
    >
      <Popup className='marker-popup'>
        <Typography variant='h7' color={"text.primary"}>{memberName || '-'}</Typography>
        <Typography variant='body1' color={"text.primary"}>{memberEmail}</Typography>
        <Divider sx={{ margin: '8px 0' }} />
        <Typography variant='h7' color={"text.primary"}>Última localização coletada:</Typography>
        <Typography variant='body1' color={"text.secondary"}><CalendarMonthRounded />{formattedDate(datetime)}</Typography>
        <Typography variant='body1' color={"text.secondary"}><LocationOnRounded />{position[0]}, {position[1]}</Typography>
        <Typography variant='body1' color={"text.secondary"}><AssignmentRounded />{description || '-'}</Typography>
        <Typography variant='body3' color={"text.secondary"}>Precisão da localização GPS: {precisionToText(precision)}</Typography>
      </Popup>
    </EnhancedMarker>
  )
}

export default MemberMarker

const stringAvatar = (name: string | undefined) => {
  if (name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`.toUpperCase()
    };
  }
}

const stringToColor = (string: string): React.CSSProperties['color'] => {
  let hash = 0;
  let i: number;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

const precisionToText = (precision?: number): string => {
  if (!precision) return 'N/A'
  switch (true) {
    case precision <= 10:
      return 'Alta'
    case precision <= 100:
      return 'Padrão'
    default:
      return 'Baixa'
  }
}

const formattedDate = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR', {
    timeStyle: 'short',
    dateStyle: 'short',
  }).format(new Date(date))
}
